import type { Route } from 'next';
import type { StaticImageData } from 'next/image';
import type { ReactNode } from 'react';
import heroImg from './assets/hero.webp';
import headerImg from './assets/header-image.webp';
import agentImg from '../../../public/assets/images/landing/work-faster.webp';

export type HeroSlide = {
  /** Eyebrow text rendered inside the `.square-subtitle` label. */
  eyebrow: string;
  /** Main headline. Use a ReactNode so slides can keep the responsive line breaks. */
  title: ReactNode;
  description: string;
  ctaLabel: string;
  ctaHref: Route;
  image: StaticImageData;
  imageAlt: string;
};

export const heroSlides: HeroSlide[] = [
  {
    eyebrow: 'Your Data. Your Rules.',
    title: (
      <>
        Control what your people{' '}
        <br className="hidden lg:inline" /> and AI agents can see,
        <br className="hidden lg:inline" /> decide, and do.
      </>
    ),
    description:
      'Zero Trust policy, unified identity, and total visibility, in one platform.',
    ctaLabel: "Let's Talk",
    ctaHref: '/contact',
    image: heroImg,
    imageAlt: 'man working on laptop',
  },
  {
    eyebrow: 'Zero Trust, Everywhere',
    title: (
      <>
        Secure every identity, device,{' '}
        <br className="hidden lg:inline" /> and action, by default.
      </>
    ),
    description:
      'Enforce least-privilege access across your entire stack without slowing your teams down.',
    ctaLabel: 'See how it works',
    ctaHref: '/what-is-primary',
    image: headerImg,
    imageAlt: 'abstract security network background',
  },
  {
    eyebrow: 'Built for AI Agents',
    title: (
      <>
        Give AI the access it needs,{' '}
        <br className="hidden lg:inline" /> and nothing more.
      </>
    ),
    description:
      'Govern exactly what autonomous agents can see and do, with policy you stay in control of.',
    ctaLabel: 'Explore agent control',
    ctaHref: '/agent-control-planes',
    image: agentImg,
    imageAlt: 'team working in a modern office overlooking the city',
  },
];
